// Shared low-level helpers used by the admin/company "Edit User" pages.
// Kept dependency-free (no React) so they can be unit tested in isolation.

export const clearTimeoutRef = (ref) => {
    if (ref.current) {
        clearTimeout(ref.current);
        ref.current = null;
    }
};

// Keyed (per-product) timeout helpers so pending work for one product isn't
// cancelled when another product is selected before its delay elapses.
export const clearKeyedTimeout = (mapRef, key) => {
    if (mapRef.current[key]) {
        clearTimeout(mapRef.current[key]);
        delete mapRef.current[key];
    }
};

export const setKeyedTimeout = (mapRef, key, fn, delay) => {
    clearKeyedTimeout(mapRef, key);
    mapRef.current[key] = setTimeout(() => {
        fn();
        delete mapRef.current[key];
    }, delay);
};

export const clearAllKeyedTimeouts = (mapRef) => {
    Object.keys(mapRef.current).forEach((key) => clearKeyedTimeout(mapRef, key));
};

export const buildBody = (base, text) => (text?.length ? { ...base, searchText: text } : base);
